import { CookieService } from 'ngx-cookie-service';
import { Constants } from '../../constants';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleHandler {

  /**
   * Locale cookie name
   * @var {string}
   */
  private readonly _localeCookieName: string = Constants.COOKIE_LOCALE;

  /**
   * Current locale
   * @var {string}
   */
  private _currentLocale: string;

  /**
   * Class constructor
   *
   * @param _cookieService
   */
  constructor(
      private _cookieService: CookieService
  ) {
    this._currentLocale = this.getCurrentLocale();
  }

  /**
   * Retrieve current locale from Cookies
   *
   * @returns {string}
   */
  public getCurrentLocale(): string {
    let languageCookie,
      currentLocale;

    if (this._cookieService.check(Constants.COOKIE_LANGUAGE)) {
      languageCookie = this._parseJsonCookie(Constants.COOKIE_LANGUAGE);

      if (languageCookie.hasOwnProperty('preferredLanguage')) {
        currentLocale = languageCookie.preferredLanguage;
      }
    } else {
      currentLocale = this._fallbackLanguageToLocaleCookie();
    }

    return currentLocale || Constants.DEFAULT_LANGUAGE;
  }

  /**
    * Gets the current language
    *
    * @returns {string}
    */
  public getCurrentLanguage(): string {
    return this._currentLocale.split('-')[0];
  }

  /**
   * Gets language based on locale (fallback strategy if language cookie is not set)
   *
   * @returns {string}
   */
  private _fallbackLanguageToLocaleCookie(): string {
    let localeCookie,
      localeLanguage;

    if (this._cookieService.check(Constants.COOKIE_LOCALE)) {
      localeCookie = this._parseJsonCookie(Constants.COOKIE_LOCALE);

      if (this._isLocaleValid(localeCookie)) {
        localeLanguage = Constants.LOCALE_MAP[localeCookie.contentLocale];
      }
    }

    return localeLanguage;
  }

  /**
   * Parses the content of a cookie
   *
   * @returns {any}
   */
  private _parseJsonCookie(cookieName: string): any {
    const rawCookieContent = this._cookieService.get(cookieName);
    let parsedCookieContent;

    try {
      parsedCookieContent = JSON.parse(rawCookieContent);
    } catch (e) {
      parsedCookieContent = rawCookieContent;
    }

    return parsedCookieContent;
  }

  /**
   * Checks if guest locale is valid
   *
   * @param localeCookie
   *
   * @returns {boolean}
   */
  private _isLocaleValid(localeCookie: any): boolean {
    return localeCookie.hasOwnProperty('contentLocale') &&
      Constants.LOCALE_MAP.hasOwnProperty(localeCookie.contentLocale);
  }
}